module.exports = __webpack_public_path__ + "static/media/Sopaconmarrano.fc3e8db3.jpg";